// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullCustomHtml {
    flex-direction: column;
    padding-bottom: 100px;
    max-width: 1320px;
    width: 100%;
}
/* .FullCustomHtml {
    margin: auto;
    width: 50%;
    height: 80px;
    background-color: red;
} */

.FullCustomHtml-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-bottom: 60px;
}

.FullCustomHtml-box {
    justify-content: center;
}

.FullCustomHtml-content {
    line-height: 100%;
    margin: auto;
    /* max-width: 700px; */
    max-width: 1320px !important;
    width: 100%;
    /* background: #fff; */
    /* padding: 40px; */
    /* border-radius: 32px; */
}

.form-error-message {
  color: red;
  font-size: 13px;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/css/FullCustomHtml.css.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;AACf;AACA;;;;;GAKG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB","sourcesContent":[".FullCustomHtml {\n    flex-direction: column;\n    padding-bottom: 100px;\n    max-width: 1320px;\n    width: 100%;\n}\n/* .FullCustomHtml {\n    margin: auto;\n    width: 50%;\n    height: 80px;\n    background-color: red;\n} */\n\n.FullCustomHtml-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-bottom: 60px;\n}\n\n.FullCustomHtml-box {\n    justify-content: center;\n}\n\n.FullCustomHtml-content {\n    line-height: 100%;\n    margin: auto;\n    /* max-width: 700px; */\n    max-width: 1320px !important;\n    width: 100%;\n    /* background: #fff; */\n    /* padding: 40px; */\n    /* border-radius: 32px; */\n}\n\n.form-error-message {\n  color: red;\n  font-size: 13px;\n  margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
